export const generateStudyYearsList = (startYear = 2017) => {
  const studyYears = [];

  const endYear = new Date().getFullYear();

  // Loop through from start year to end year
  for (let year = startYear; year <= endYear; year++) {
    const studyYear = `${year}/${year + 1}`;
    studyYears.push(studyYear);
  }

  const result = studyYears.map((item, i) => ({
    value: item,
    label: item,
  }));

  return result.reverse();
};

export const getYearsList = () => {
  const currentYear = new Date().getFullYear();
  const startYear = 2017;
  const years = [];

  for (let year = startYear; year <= currentYear; year++) {
    years.push({
      value: year,
      label: year,
    });
  }

  return years.reverse();
};

export const generateSemesterList = () => {
  return [
    {
      value: "GASAL",
      label: "GASAL",
    },
    {
      value: "GENAP",
      label: "GENAP",
    },
  ];
};

export const formatToRupiah = (numberString) => {
  // Create an Intl.NumberFormat formatter with desired options
  const numberFormatter = new Intl.NumberFormat("en-US", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  const formattedNumber = numberFormatter.format(numberString);
  return !isNaN(numberString) ? formattedNumber : null;
};

export const removeFormatter = (value) => {
  // Split input by dot
  const parts = `${value}`.replace(/,/g, "").split(".");

  // Format integer part with thousand separator
  let result = parts[0];

  // Check if there's a decimal part
  if (parts.length === 2) {
    // Limit decimal part to maximum three digits
    const decimalPart = parts[1].substring(0, 2);
    result += "." + decimalPart;
  }

  return result;
}

export const formatNumber = (value) => {
  // Remove non-numeric characters except dot
  const numericInput = `${value}`.replace(/[^\d.]/g, "");

  // // Check if input is empty or invalid
  // if (!value || isNaN(Number(value))) {
  //   return "0";
  // }

  // Split input by dot
  const parts = numericInput.split(".");

  // Format integer part with thousand separator
  let formattedInteger = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Check if there's a decimal part
  if (parts.length === 2) {
    // Limit decimal part to maximum three digits
    const decimalPart = parts[1].substring(0, 2);
    formattedInteger += "." + decimalPart;
  }

  return formattedInteger;
};

export const removeTrailingZero = (number) => {
  // Use toFixed to get a fixed number of decimal places
  const formattedNumber = parseFloat(number).toFixed(2);

  // Check if parsedNumber is NaN, return 0 if true
  if (isNaN(formattedNumber)) {
    return "0";
  }

  // Add thousand separators
  const numberWithCommas = formattedNumber.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ","
  );

  // Remove trailing zeros from the decimal part
  const trimmedNumber = numberWithCommas.replace(/\.?0+$/, "");

  return trimmedNumber;
};

export const validateNumericInput = (input, maxLength) => {
  // Remove non-numeric characters
  const numericInput = input.replace(/\D/g, '');

  // Apply maximum length constraint
  const validatedInput = numericInput.slice(0, maxLength);

  return validatedInput;
};

export const listStaffMenu = [
  {
    value: 'va',
    label: "VA",
  },
  {
    value: 'permohonan',
    label: "PERMOHONAN",
  },
  {
    value: 'praktikum',
    label: "PRAKTIKUM",
  },
];